import {TextArea as PepsicoDsTextArea} from 'pepsico-ds'
import './_textArea.scss'

/**
 * TextArea component renders a text area input field with various properties.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.value - The current value of the text area.
 * @param {Function} props.updateValue - Function to update the value of the text area.
 * @param {string} props.label - The label for the text area.
 * @param {string} props.error - Error message to display.
 * @param {Object} props.uiSchema - UI schema object containing additional configurations.
 * @param {string} [props.uiSchema.helperText=''] - Helper text to display below the text area.
 * @param {string} [props.uiSchema.className=''] - Additional class names for styling.
 * @param {string} [props.uiSchema.placeholder=''] - Placeholder text for the text area.
 * @param {boolean} [props.uiSchema.showToolbar=false] - Whether to show the toolbar.
 * @param {boolean} [props.uiSchema.showCharacterCount=false] - Whether to show the character count.
 * @param {boolean} [props.disabled=false] - Indicates if the text area is disabled.
 * @param {string} [props.id=''] - Optional additional id to apply to the text area.
 * @returns {JSX.Element} The rendered text area component.
 */
export default function TextArea({value, updateValue, label, error, uiSchema, disabled = false, id, maxLength}) {
  return (
    <PepsicoDsTextArea
      id={`text-area` + (id ? `_${id}` : '')}
      data-testid={`text-area` + (id ? `_${id}` : '')}
      helperText={uiSchema.helperText}
      isDark
      label={label}
      className={`${uiSchema.className} mr-8${disabled ? ' textarea-disabled' : ''}`}
      value={value === '' ? undefined : value}
      disabled={disabled}
      placeholder={uiSchema.placeholder}
      showCharacterCount={uiSchema.showCharacterCount || false}
      maxLength={maxLength}
      onUpdate={value => {
        updateValue(value)
      }}
      onChange={e => {
        const value = e.target.value
        updateValue(value)
      }}
      onBlur={() => {
        const trimmedValue = value?.trim()
        updateValue(trimmedValue)
      }}
      showToolbar={uiSchema.showToolbar}
      htmlMode={uiSchema.htmlMode || false}
      error={error}
      style={{width: '100%'}}
    />
  )
}
